/**
 * A theme mode for the visualization. It refers to the container element for the UI element.
 * overlay: UI element is shown inside a standard DOM element
 * dialog: UI element is shown inside a dialog
 */
export enum VisualizationMode {
  DOM = 'dom',
  Dialog = 'dialog'
}
